import { BUSINESS_INFO as business_info } from './businessInfo';
import { CONNECT_GSUITE as connect_gsuite } from './connectGsuite';

export const ONBOARDING = {
  business_info,
  connect_gsuite
};
